import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/portfolioLogo1.png";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import { IoLogoWhatsapp } from "react-icons/io";
import { AiOutlineContacts } from "react-icons/ai";
import {
  AiFillStar,
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
  AiFillContacts
} from "react-icons/ai";

import { CgFileDocument } from "react-icons/cg";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="/" className="d-flex">
          <img src={logo} className="img-fluid logo" alt="brand" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        // className="NavToggle"
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)}>
                <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/about"
                onClick={() => updateExpanded(false)}
              >
                <AiOutlineUser style={{ marginBottom: "2px" }} /> About
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/project"
                onClick={() => updateExpanded(false)}
              >
                <AiOutlineFundProjectionScreen
                  style={{ marginBottom: "2px" }}
                />{" "}
                Projects
              </Nav.Link>
            </Nav.Item>

            {/* <Nav.Item>
              <Nav.Link
                as={Link}
                to="/resume"
                onClick={() => updateExpanded(false)}
              >
                <CgFileDocument style={{ marginBottom: "2px" }} /> Resume
              </Nav.Link>
            </Nav.Item> */}

            <Nav.Item>
              <Nav.Link
                // href=""
                as={Link}
                // target="_blank"
                to="/contact-us"
                onClick={() => updateExpanded(false)}
                rel="noreferrer"
              >
                <AiOutlineContacts style={{ marginBottom: "2px" }} className="textWhite" /> Contact
              </Nav.Link>
            </Nav.Item>

            <Nav.Item className="fork-btn">
              <Button
                href="mailto:akhiltrackgen2022@gmail.com"
                // href="https://api.whatsapp.com/send?phone=918547621613&text=Hi%20there!%20Thanks%20for%20reaching%20out%20.%20We%27re%20excited%20to%20connect%20with%20you%20and%20help%20you%20bring%20your%20online%20presence%20to%20life.%20We%20provide%20high-quality%20website%20design%20and%20development%20services%20to%20businesses%20of%20all%20sizes.%20Whether%20you%27re%20looking%20to%20create%20a%20new%20website%20or%20improve%20an%20existing%20one%2C%20we%27re%20here%20to%20help.%20Feel%20free%20to%20ask%20us%20any%20questions%20you%20have%20about%20our%20services%2C%20and%20we%27ll%20do%20our%20best%20to%20provide%20you%20with%20the%20information%20you%20need.%20Let%27s%20work%20together%20to%20build%20the%20perfect%20website%20for%20your%20business!"
                target="_blank"
                className="fork-btn-inner"
              >
                {/* <CgGitFork style={{ fontSize: "1.2em" }} />{" "} */}
                <MdEmail style={{ fontSize: "1.5em", color: "white" }} />
              </Button>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
